import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import ReactTable from "react-table"
import _ from 'lodash'
import { Link } from 'react-router-dom'
import clone from 'clone'
import FullTable from 'components/FullTable'
import moment from "moment"
import numeral from 'numeral'
import helpers from "helpers/helpers"
import settings from 'settings'
import getData from "helpers/submitData"

class SectionManagement extends Component {

	constructor(props) {
		super(props)

		this.state = {
			columns: [
				{
					Header: "ID",
					accessor: "id",
				},
				{
					Header: settings?.renames?.section || "Section",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Subdivision",
					accessor: "subdivision",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Developer",
					accessor: "developer",
					filterMethod: (f, r) => helpers.tableText(f, r, "developer"),
				},
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Has Plat File",
					accessor: "has_plat",
					filterMethod: (f, r) => helpers.tableText(f, r, "has_plat"),
				},
				{
					Header: "# of Platted Lots",
					accessor: "platted_lots",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.platted_lots
						})
						return numeral(total).format("0,0")
					},
				},
				{
					Header: "Lots Uploaded",
					accessor: "uploaded_lots",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.uploaded_lots
						})
						return numeral(total).format("0,0")
					},
				},
				{
					Header: "Plotted Difference",
					accessor: "difference",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.difference
						})
						return numeral(total).format("0,0")
					},
				},
				{
					Header: "Acreage",
					accessor: "acreage",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.acreage
						})
						return numeral(total).format("0,0.00")
					},
				},
				{
					Header: "Substantially Complete",
					accessor: "complete",
					filterMethod: (f, r) => helpers.tableText(f, r, "complete"),
				},
				{
					Header: "Substantial Complete Date",
					accessor: "completion",
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("M/DD/YY")
						return ""
					},
				},
				{
					Header: "Active Adult",
					accessor: "senior",
					filterMethod: (f, r) => helpers.tableText(f, r, "senior"),
				},
				{
					Header: "BTR",
					accessor: "btr",
					filterMethod: (f, r) => helpers.tableText(f, r, "btr"),
				},
				{
					Header: "Mapped",
					accessor: "mapped",
					filterMethod: (f, r) => helpers.tableText(f, r, "mapped"),
				},
				{
					Header: "Edit",
					accessor: "edit",
					filterable: false,
				},
			],
			properties: [],
		}
	}

	componentDidMount() {
		getData("mainRetrieve", {
			action: "allPropertiesQuick",
		})
			.then((resp) => {
				this.setState({ properties: resp.data }, () => {
					//console.log(this.state)
				})
			})
			.catch((e) => {
				console.log(e)
			})
	}

	buildTable = type => {
        let data = []
		_.forEach(this.props.payload.public.sections, v => {
			if(!this.props.activeProperties.includes(v.property)) {
				return
			}
			let p = clone(v)
			let property = _.find(this.state.properties, {id: v.property})
			if(property) {
				p.property = property.name
			}
			let subdivision = _.find(this.props.payload.public.subdivisions, { id: v.subdivision })
			if (subdivision) {
				p.subdivision = subdivision.name
			}
			let developer = _.find(this.props.payload.public.developers, { id: v.default_developer })
			if (developer) {
				p.developer = developer.name
			}
			let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: v.neighborhood })
			if (neighborhood) {
				p.neighborhood = neighborhood.name
			}
			// lookpu if mapped
			p.mapped = 'No'
			let geo = _.get(property, `section_geo.features`)
			if(geo) {
				let mappedLookup = _.find(property.section_geo.features, r => {
					try {
						if (r.properties.Id == v.id) return true
					} catch (e) {
						console.log(e)
					}
				})
				if (mappedLookup) p.mapped = "Yes"
			}
			p.has_plat = v.plat_file ? 'Yes' : 'No'
			p.id = v.id
			p.name = v.name
			p.complete = v.substantially_complete ? 'Yes' : 'No'
			p.senior = v.senior ? 'Yes' : null
			p.btr = v.btr ? 'Yes' : null
			let uploaded = _.filter(this.props.payload.exec.lots, r => {
				if(r.section_id == v.id) return true
			})
			p.uploaded_lots = uploaded.length
			let diff = ''
			if(typeof p.platted_lots == 'number' && typeof uploaded.length == 'number') {
				diff = p.platted_lots - uploaded.length
			}
			p.difference = diff

			p.edit = (
                <Link to={`/admin/sections/${v.id}`}>
                    <i className="far fa-edit"></i>
                </Link>
            )
			delete p.lot_types
			delete p.mud
			data.push(p)
		})
		return data
    }

	render() {
		
		if(this.props.payloadStatus){
			return (
				<div className="admin">
					<Title title={`${settings?.renames?.section || "Section"} Management`} showDate={false} />
					<div className="content">
						<div className="admin__add">
							<Link to={"/admin/sections/add"}>
								<i className="fas fa-plus-circle" />
							</Link>
						</div>
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="sections"
							title="Sections"
							classNames={"small"}
							unset={['edit']}
							pageSize={20}
						/>
					</div>
				</div>
			)
		}
		else {
			return('')
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(SectionManagement)
